<template>
  <div class="csv-test-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>CSV数据生成测试</span>
      </div>
      
      <div class="content">
        <el-button type="primary" @click="generateAndShowStats">生成数据统计</el-button>
        
        <div v-if="stats" class="stats-area">
          <h3>数据统计结果</h3>
          <el-table :data="statsTableData" border style="width: 100%; margin-top: 20px;">
            <el-table-column prop="type" label="订单类型" width="180"></el-table-column>
            <el-table-column prop="count" label="数量" width="120"></el-table-column>
            <el-table-column prop="description" label="说明"></el-table-column>
          </el-table>
          
          <div class="price-distribution">
            <h4>价格分布统计</h4>
            <el-table :data="priceStatsData" border style="width: 100%; margin-top: 10px;">
              <el-table-column prop="price" label="价格" width="120"></el-table-column>
              <el-table-column prop="count" label="数量" width="120"></el-table-column>
              <el-table-column prop="percentage" label="占比"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { generateOrderCsvData } from '@/utils/generateOrderCsv';

export default {
  name: 'CsvTest',
  data() {
    return {
      stats: null,
      statsTableData: [],
      priceStatsData: []
    };
  },
  methods: {
    generateAndShowStats() {
      try {
        const csvData = generateOrderCsvData();
        const rows = csvData.split('\n');
        
        // 跳过标题行
        const dataRows = rows.slice(1).filter(row => row.trim());
        
        // 统计数据
        const stats = {
          total: dataRows.length,
          coachOrders: 0,
          storeOrders: 0,
          memberOrders: 0,
          priceDistribution: {}
        };
        
        dataRows.forEach(row => {
          const columns = this.parseCsvRow(row);
          if (columns.length >= 13) {
            const rchargeType = columns[7].replace(/"/g, '');
            const amount = parseFloat(columns[2]);
            
            // 统计订单类型
            if (rchargeType === 'need_full') {
              stats.coachOrders++;
            } else if (rchargeType === 'study_card') {
              stats.storeOrders++;
            } else if (rchargeType === 'member') {
              stats.memberOrders++;
            }
            
            // 统计价格分布
            if (!stats.priceDistribution[amount]) {
              stats.priceDistribution[amount] = 0;
            }
            stats.priceDistribution[amount]++;
          }
        });
        
        this.stats = stats;
        
        // 构建统计表数据
        this.statsTableData = [
          { type: '教练订单', count: stats.coachOrders, description: 'rcharge_type: need_full' },
          { type: '门店订单', count: stats.storeOrders, description: 'rcharge_type: study_card' },
          { type: '会员卡订单', count: stats.memberOrders, description: 'rcharge_type: member' },
          { type: '总计', count: stats.total, description: '所有订单总数' }
        ];
        
        // 构建价格分布表数据
        this.priceStatsData = Object.entries(stats.priceDistribution).map(([price, count]) => ({
          price: `¥${price}`,
          count: count,
          percentage: `${((count / stats.total) * 100).toFixed(2)}%`
        })).sort((a, b) => parseFloat(a.price.replace('¥', '')) - parseFloat(b.price.replace('¥', '')));
        
        this.$message.success(`数据生成成功！共生成 ${stats.total} 条订单记录`);
      } catch (error) {
        console.error('生成失败:', error);
        this.$message.error('生成失败，请查看控制台');
      }
    },
    
    parseCsvRow(row) {
      const result = [];
      let current = '';
      let inQuotes = false;
      
      for (let i = 0; i < row.length; i++) {
        const char = row[i];
        
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          result.push(current);
          current = '';
        } else {
          current += char;
        }
      }
      
      result.push(current);
      return result;
    }
  }
};
</script>

<style scoped lang="less">
.csv-test-container {
  padding: 20px;
  
  .box-card {
    max-width: 1000px;
    margin: 0 auto;
  }
  
  .content {
    .stats-area {
      margin-top: 30px;
      
      h3 {
        margin-bottom: 15px;
        color: #303133;
      }
      
      h4 {
        margin-top: 30px;
        margin-bottom: 10px;
        color: #606266;
      }
    }
  }
}
</style>